export const encode = (str: string) => window.btoa(unescape(encodeURIComponent(str)));

export const decode = (str: string) => decodeURIComponent(escape(window.atob(str)));
